import { floor } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import './image-column-viewer.scss';

export const originalImageWidth = 600;

const ImageColumnViewer = ({ zoomInPastMinimum,
  trackHeight,
  moved,
  zoom,
  setZoom,
  yOffset,
  updateDepth,
  mouseWheelZoom,
  ctrlKeyPressed,
  filter,
  setMetaData,
  metaData,
  scaleImageFileNames,
  scaledImageHeight,
  apiUrl,
  clientId,
  projectId,
  boreholeId,
  imageType,
  authToken, 
  isCuttings }: any) => {

  //const [zoom, setZoom] = useState<number>(0.5);
  const [isPanning, setPanning] = useState(false);
  const [position, setPosition] = useState({
    oldX: 0,
    oldY: 0,
    x: 0,
    y: 0
  });

  const ref = useRef<any>(null);

  // useEffect(() => {
  //  calculateDepth(position.y, zoom / 2);
  // },[]);

  useEffect(() => {
    if (yOffset != null) {      
      setPosition({
        ...position,
        y: yOffset
      });
      
      calculateDepth(yOffset, zoom);
    }
  }, [yOffset]);

  const imageWidth = 600 / (getBaseLog((1 / zoom), 2) + 1);
  if (!imageWidth) {
    debugger;
  }

  // useEffect(() => {
  //   if (position != null && ref.current.clientHeight > 0) {
  //     let newY = position.y;
  //     const maxY = getMaxY();
  //     if (newY > 0) {
  //       newY = 0;
  //     }
  //     if (newY < maxY) {
  //       if (maxY < 0) {
  //         newY = maxY;
  //       } else {
  //         newY = 0;      
  //       }
  //     }

  //     if (newY != position.y) {
  //       setPosition({
  //         ...position,
  //         y: newY
  //       });
  //       calculateDepth(yOffset, zoom);
  //     }
  //   }
  // }, [position]);

  const onMouseDown = (e: any) => {
    e.preventDefault();
    setPanning(true);
    setPosition({
      ...position,
      oldX: e.clientX,
      oldY: e.clientY
    });
  };

  const onMouseMove = (event: any) => {
    if (!isPanning) {
      var columns = getColumns(zoom);
     // console.log("random zoom", zoom);
   //   console.log("random columns", columns);
      var imageHeight = getImageHeight(zoom);
      let rect = ref.current.getBoundingClientRect();
      let x = event.clientX - rect.left; //x position within the element.
      let y = event.clientY - rect.top;  //y position within the element.

      var cursorPoistion = y;
      var cursorDepth = Math.floor((cursorPoistion / imageHeight)) * columns;//(((-position.y + y -(imageHeight / 2)) / imageHeight) * columns);

      var xOffset = x * columns / originalImageWidth;

      // this needs to be worked out using new method

      var sectionNumber = cursorDepth + Math.floor(xOffset) + 1;
      var depth = Math.round((cursorDepth + xOffset) * 100) / 100;
      setMetaData(sectionNumber, xOffset - Math.floor(xOffset));
    }
  };

  const getImageHeight = (zoom: number) => {    
    if (isCuttings) {
      return Math.abs((600 / (getBaseLog((zoom), 2) - 1))) * 4 / 6;      
    }

    
    return (scaledImageHeight / getColumns(zoom));
  }


  const getColumns = (zoom: number) => {   
    if (isCuttings) {
      return 1;
    }
    
     return (getBaseLog((1 / zoom), 2) + 1);
  }

  const getMaxY = (zoom: number) =>  {
    var imageHeight = getImageHeight(zoom);
    return trackHeight - ref.current.clientHeight - trackHeight + imageHeight;
  }

  useEffect(() => {
    const mouseup = () => {
      setPanning(false);
    };

    const mousemove = (event: any) => {
      if (isPanning) {
        let newY = position.y + event.clientY - position.oldY;        
        
        const maxY = getMaxY(zoom);
        if (newY > 0) {
          newY = 0;
        }
        if (newY < maxY) {
          if (maxY < 0) {
            newY = maxY;
          } else {
            // don't move
            //return;            
          }
        }

        setPosition({
          ...position,
          x: position.x,
          y: newY,
          oldX: event.clientX,
          oldY: event.clientY,
        });
        moved({ yOffset: newY }, true);
        calculateDepth(newY, zoom);
      }
    };

    window.addEventListener('mouseup', mouseup);
    window.addEventListener('mousemove', mousemove);

    return () => {
      window.removeEventListener('mouseup', mouseup);
      window.removeEventListener('mousemove', mousemove);
    };
  });

  const onWheel = (event: any) => {
    if (!mouseWheelZoom && !ctrlKeyPressed) {      
      var bottom = -ref.current.clientHeight + trackHeight;

      var panAmount = event.deltaY > 0 ? -20 : 20;

      var newY = position.y += panAmount;
      if (newY < bottom) {
        newY = bottom > 0 ? 0 : bottom;
      }

      if (newY > 0) {
        newY = 0;
      }
      setPosition({
        ...position,
        y: newY
      });
      
      moved({ yOffset: newY }, true);
      calculateDepth(newY, zoom);

    } else {
      let rect = ref.current.getBoundingClientRect();
      let x = event.clientX - rect.left; //x position within the element.
      let y = event.clientY - rect.top;  //y position within the element.

      if (event.deltaY < 0) {
        // zoom in
          var columns = getColumns(zoom);
          var imageHeight = getImageHeight(zoom);
          var cursorPoistion = y;
          var cursorDepth = Math.floor((cursorPoistion / imageHeight)) * columns;//(((-position.y + y -(imageHeight / 2)) / imageHeight) * columns);
          var xOffset = x * columns / originalImageWidth;
          var sectionNumber = cursorDepth + Math.floor(xOffset) + 1;
        
        if (zoom < 0.5) {   
          
          //work out which image is under the mouse when it zooms in
          
          

          // now we have the section number we can work out the new offset based on the new zoom level
          const newZoom = zoom * 2;
          // work out the number of sections that are visible for the new zoom level
          let newY = 0; // calculateOffset(sectionNumber, newZoom);
          if (isCuttings) {
            const imageHeight2 = getImageHeight(newZoom);
            const visibleSections = trackHeight / imageHeight2;
            const offset = (sectionNumber -(visibleSections / 2)) * imageHeight2;
            newY = -offset; // calculateOffset(sectionNumber, newZoom);
          } else {            
            newY = calculateOffset(sectionNumber, newZoom);
            newY += trackHeight / 2;
          }
          
          setPosition({
            ...position,
            y: newY
          });
          moved({ yOffset: newY, zoom: newZoom }, true);
          calculateDepth(newY, newZoom);
          //setZoom(zoom * 2);
        } else {          
          zoomInPastMinimum(sectionNumber);
        }
      } else {
        // zoom out
        let newY = 0;
        const newZoom = zoom / 2;
        if (isCuttings) {
          var columns = getColumns(zoom);
          var imageHeight = getImageHeight(zoom);
          var cursorPoistion = y;
          var cursorDepth = Math.floor((cursorPoistion / imageHeight)) * columns;//(((-position.y + y -(imageHeight / 2)) / imageHeight) * columns);
          var xOffset = x * columns / originalImageWidth;
          var sectionNumber = cursorDepth + Math.floor(xOffset) + 1;

          // now we have the section number we can work out the new offset based on the new zoom level
          
          // work out the number of sections that are visible for the new zoom level
          const imageHeight2 = getImageHeight(newZoom);
          const visibleSections = trackHeight / imageHeight2;
          const offset = (sectionNumber -(visibleSections / 2)) * imageHeight2;


                  
          // if (ref.current.clientHeight < height) {
          //   newY = 0;
          // } else {
            newY =  -offset;// calculateOffset(currentDepth, zoom / 2);
            // const maxY = getMaxY(zoom / 2);          
            // if (newY < maxY) {
            //   if (maxY < 0) {
            //     newY = maxY;
            //   } else {
            //     newY = 0;      
            //   }
            // }
      //   }
        } else {          
          // work out new offset given the same start depth
          const currentDepth = calculateSectionNumber(y, zoom);          
          // if (ref.current.clientHeight < height) {
          //   newY = 0;
          // } else {
          newY = calculateOffset(currentDepth, newZoom);
          newY += trackHeight / 2;
        }

        setPosition({
          ...position,
          y: newY
        });
        moved({ yOffset: newY, zoom: newZoom }, true);
        calculateDepth(newY, newZoom);
        //setZoom(zoom / 2);
      }
    }
  }

  const calculateStartDepth = (y: any, zoom: any) => {
    // var columns = getColumns();
    //var imageHeight = (originalImageHeight / columns) + 2;
    //var startDepth = (((-y - (imageHeight / 2)) / imageHeight) * columns);

    return calculateSectionNumber(y, zoom);
  }

  const calculateSectionNumber = (y: number, zoom: any) => {    
    if (!metaData) {
      return 1;
    }
    
    const columns = getColumns(zoom);

    var imageHeight = calculateCurrentPixelHeight(zoom);
    let pixelCount = 0; //imageHeight;
    let imageIndex = 0;
    let lastSection =  metaData.imageSizes[0]?.section ?? 0;
    const absY = Math.abs(y);
    if (zoom < 0.5) {
      //debugger;
    }
    
    while (pixelCount <= absY && imageIndex < metaData.imageSizes.length) {
      if (imageIndex % columns == 0) {
        const imageSize = metaData.imageSizes[imageIndex];
        if (imageSize == null) {
          debugger;
        }
        
        pixelCount += imageHeight;
        lastSection = imageSize.section;
      }

      imageIndex++;
    }

    if (imageIndex === metaData.imageSizes.length) {
      return lastSection;
    }

    const remainder = absY - pixelCount;
    const imageSize = metaData.imageSizes[imageIndex];
    if (isCuttings) {
      return lastSection + (remainder / calculateCurrentPixelHeight(zoom)) + 0.5;
    } else {
      return lastSection + (remainder / calculateCurrentPixelHeight(zoom)) - 1;
    }
  };

  function roundHalf(num: number) {
    return Math.round(num * 2) / 2;
  }

  const calculateOffset = (sectionNumber: number, zoom: any) => {
    const columns = getColumns(zoom);

    const previousImages = metaData.imageSizes.filter((i: any) => i.section <= sectionNumber);
    let offsetY = 0;
    previousImages.forEach((imageSize: any, index: number) => {
      if (index % columns == 0) {
        offsetY += roundHalf(calculateCurrentPixelHeight(zoom));
      }
    });

    return -offsetY;
  };

  const calculateCurrentPixelHeight = (zoom: number) => {    
    return getImageHeight(zoom);
  }

  const calculateDepth = (y: any, zoom: any) => {
    if (updateDepth) {
      var columns = getColumns(zoom);
      
      var imageHeight = getImageHeight(zoom);
      if (zoom < 0.5) {
        //debugger;
      }

      console.log("random y", y);
      const startDepth = calculateStartDepth(y, zoom);
      const depthHeight = (trackHeight / imageHeight) * columns;
      let endDepth = startDepth + depthHeight;
      if (!isCuttings) {
        endDepth -= 0.5;
      }
      console.log("random startDepth", startDepth);
      console.log("random endDepth", endDepth);
      updateDepth(startDepth, endDepth);
    }
  }

  function getBaseLog(y: any, x: any) {
    return Math.log(y) / Math.log(x);
  }




const imageClass = isCuttings ? "cuttings-image" : "test-image";

  return (
    <div className="image-viewer-column" style={{ height: trackHeight, filter: filter }} onWheel={onWheel}  onMouseDown={onMouseDown}>
      <div ref={ref} className="image-viewer-column" onMouseMove={onMouseMove} style={{ transform: `translate(${position.x}px, ${position.y}px)` }}>
        {(scaleImageFileNames || []).map((fileName: any, index: number) => (          
            <div key={index} className={imageClass} style={{ width:`${imageWidth}px`, height: `${getImageHeight(zoom)}px` }}>
              <img key={index} 
                   loading="lazy" 
                   width={imageWidth} 
                   height={getImageHeight(zoom)}
                   src={`${fileName}`} />
            </div>                      
        ))}

      </div>
    </div>
  );
};

export default ImageColumnViewer;